var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-layout"},_vm._l((_vm.groups),function(group,name){return _c('setting-card',{key:name,attrs:{"group-name":name,"group":group},on:{"submit":_vm.handleSubmit}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }